import { useState } from "react";
import GetMonthsOpt from "../../../Dropdowns/getSelectMonth.js";
import GetYearsOpt from "../../../Dropdowns/getSelectYear.js";
import EKYCCardsUnitsDistricts from "./EKYCCardsUnitsDistricts.jsx";

const EKYCCardsUnitsInit = () => {

  const [renderContent, setRenderContent] = useState(null);  
  const [loading, setLoading] = useState(true);

  const handleLoadingChange = (isLoading) => {
    setLoading(isLoading);
  };

  const handleMonthsLoadingChange = (isLoading) => {
    handleLoadingChange(isLoading);
  };

  const handleYearsLoadingChange = (isLoading) => {
    handleLoadingChange(isLoading);
  };

  const handleSubmit = async () => {
    const month = document.getElementById("month").value;
    const year = document.getElementById("year").value;

    const distMonthName =
      document.getElementById("month").options[
        document.getElementById("month").selectedIndex
      ].text;

    if (month == null || month == "") {
      alert("Please select Distribution Month");
      return false;
    } else if (year == null || year == "") {
      alert("Please select Distribution Year");
      return false;
    } else {
      setRenderContent(null);

      setRenderContent(
        <EKYCCardsUnitsDistricts
         key={`${month}-${year}`} 
          distMonth={month}
          distYear={year}       
          distMonthName={distMonthName}         
        />
      );
    }
  };

  return (
    <>
      <div
        className="wrapper row3"
        style={{ maxHeight: "95vh", paddingBottom: "40px" }}
      >
        {" "}
      </div>

      <div id="container">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "10px",
          }}
        >
          <table width="50%">
            <thead>
              <tr className="tableheader">
                <th colSpan={4}>EKYC Card Unit Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Distribution Month :</td>
                <td>
                  <GetMonthsOpt
                    input_id="month"
                    onLoadingChange={handleMonthsLoadingChange}
                  />
                </td>
                <td>Distribution Year:</td>
                <td>
                  <GetYearsOpt
                    input_id="year"
                    onLoadingChange={handleYearsLoadingChange}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="10" align="center">
                  {
                    <button
                      className="button button2"
                      style={{ marginRight: "10px" }}
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  }
                  <button
                    className="button button2"
                    onClick={() => window.history.back()}
                  >
                    Back
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

       <div id="loading" style={{ display: "none", textAlign: "center" }}>
          <img src="images/progress.gif" alt="Loading" />
        </div>

        <div id="districtDetails">{renderContent}</div>
    </>
  );
};

export default EKYCCardsUnitsInit;
